import React from 'react';
import StartInterviewLayout from '../../components/layout/StartInterviewLayout';

const Dart = () => {
  return (
    <StartInterviewLayout type="dart"/>
  )
}

export default Dart;